// Central product configuration — single source of truth.
// Do not hard-code these values independently across components.

export const CONFIG = {
  company: "Xylapay",
  product: "XylaFi Platinum",
  token: "XPTY",
  asset: "Platinum",
  element: "Pt",
  network: "Solana",
  price: 0.5649, // USD
  metalPerToken: "10 mg",
  tokensPerGram: 100,
  contractAddress: null,
  buyUrl: "https://jup.ag/tokens/XptdvMzYQmDqxGr8cneyy7sxSPecNrG6w9d6av6t1Fg",
  whitepaperUrl: "/XPTY-Whitepaper.pdf",
  explorerUrl: null,
  documentationUrl: null,
};

export const formatPrice = (v) =>
  `$${Number(v).toLocaleString("en-US", { minimumFractionDigits: 4, maximumFractionDigits: 4 })}`;
